// Таблица планировок

import {h} from 'preact';
import AbstractListView, {
	AbstractListViewProps,
	AbstractListViewState,
} from './AbstractListView';
import ListItem from './ListItem';
import {StateListDataItem} from './Store/State';

/**
 * Таблица планировок
 */
class List extends AbstractListView
{
	/**
	 * Render component
	 */
	public render(
		_props: AbstractListViewProps,
		{items}: AbstractListViewState,
	): JSX.Element
	{
		return (
			<div class="apartments">
				<ul>
					{
						items.map(
							( item: StateListDataItem ) => (
								<ListItem
									key={String( item.id )}
									{...item}
								/>
							),
						)
					}
				</ul>
			</div>
		);
	}
}

/**
 * Module
 */
export {
	List as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/List.tsx